<template>
    <footer class="footer"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
            <nav>
                <ul>
                    <li>
                        <a href="https://play.google.com/store/apps/details?id=com.viainno.spacesgo">
                            <img :src="google_play" />
                        </a>
                    </li>
                    <li>
                        <a href="https://itunes.apple.com/tw/app/spaces-go/id1444387614">
                            <img :src="app_store" />
                        </a>
                    </li>                   
                </ul>
            </nav>
            <div class="copyright">Copyright © 2019 Viainno Spaces Go  <a href="javascript:void(0)" >服務條款</a><router-link to="/privacy">隱私權政策</router-link></div>
             <div class="right"><a href="#"><img :src="fb" /></a>&nbsp;&nbsp;&nbsp;<a href="#"><img :src="line" /></a></div>
        </div>
    </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
     app_store: {
      type: String,
      default: require("@/assets/img/logo/app_store.png")
    },
    google_play: {
      type: String,
      default: require("@/assets/img/logo/google_play.png")
    },
    fb: {
      type: String,
      default: require("@/assets/img/logo/fb.png")
    },
    line: {
      type: String,
      default: require("@/assets/img/logo/line.png")
    },
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.right{    
    position: absolute;
    top: 10px;
    right: 10px;
}
.right img
{
    width: 24px;
    height: 25px;
}
.copyright{    
    margin:10px auto 0 auto !important;
    padding: 0 !important;
}
.copyright a{
    padding-left: 8px;
}
/* .copyright a,.copyright a:visited
{
    color: #9b9b9b !important;
    text-decoration: none;    
    cursor: pointer;
    padding-left: 8px;
}
.copyright a:hover
{
    text-decoration: none;
	color: #468;
} */
.footer .container{    
    text-align:left !important;
}
.footer ul li a{
    padding: 10px 5px 0 15px !important;
}
</style>
